import { axios } from "utils";

import { PUBLIC_FIELDS_URL as endpoint } from "consts";

import { Coordinates, FieldShape } from "models";

export const getFieldShape = async (data: { fieldId: string; type?: string; highQuality?: boolean }): Promise<{ fieldShape: FieldShape; success: boolean }> =>
  axios.get(`${endpoint}/${data.fieldId}/shapes`, { data });

export const getFieldShapes = async (): Promise<{ fieldShapes: FieldShape[] }> => axios.get(`${endpoint}/shapes`);

export const getDigifarmShape = async ({
  location,
  signal,
}: {
  location: Coordinates;
  signal: AbortSignal;
}): Promise<{ digifarmShape: Coordinates[]; success: boolean }> => axios.post(`${endpoint}/shapes/digifarm`, { data: { location }, signal });

export const getShapefileSetting = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/shapefile-setting`, { data, signal: data.signal });
